import cn from 'classnames';
import { FC } from 'react';

import { Patient } from '@/shared/api/protocol-ts/model/dto_patient_pb';
import studyPlaceholderImage from '@/shared/assets/images/cats/patientListStudyPlaceholder.png';
import { useAppSelector } from '@/shared/hooks';
import { getImageSrc, getName } from '@/shared/lib';

import { userModel } from '@/entities/user';

import styles from '../PatientList/PatientList.module.scss';
import { PatientNameTooltip } from '../PatientNameTooltip/PatientNameTooltip';

type PatientNameCellProps = {
  patient: Patient;
  className?: string;
};

export const PatientNameCell: FC<PatientNameCellProps> = (props) => {
  const { patient, className } = props;

  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);

  const patientFullName = getName(
    patient.PersonalData?.FirstName,
    patient.PersonalData?.LastName,
    { userLocale },
  );

  const displayAssetID = patient.DisplayAssetID;
  const patientStudyImage = getImageSrc(displayAssetID, 'thumbnail');

  return (
    <div
      className={cn(styles.infoInCell, className)}
      data-component="patient-name-cell"
    >
      {displayAssetID ? (
        <object
          data={patientStudyImage}
          type="image/png"
          className={styles.patientStudyImage}
        >
          <img
            src={studyPlaceholderImage}
            alt={`${patientFullName}-avatar`}
            className={styles.patientStudyImage}
          />
        </object>
      ) : (
        <img
          src={studyPlaceholderImage}
          alt={`${patientFullName}-avatar`}
          className={styles.studyPlaceholderImage}
        />
      )}

      <PatientNameTooltip name={patientFullName}>
        <div
          data-ph-mask
          className={cn(
            styles.fullName,
            !displayAssetID && styles.paddingForFullName,
          )}
        >
          {patientFullName}
        </div>
      </PatientNameTooltip>
    </div>
  );
};
